import { render, staticRenderFns } from "./regressionTable.vue?vue&type=template&id=75a531f3&scoped=true"
import script from "./regressionTable.vue?vue&type=script&lang=js"
export * from "./regressionTable.vue?vue&type=script&lang=js"
import style0 from "./regressionTable.vue?vue&type=style&index=0&id=75a531f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a531f3",
  null
  
)

export default component.exports